/**
 * Create Docuseal template from HTML on Docuseal (via API).
 *
 * @endpoint POST https://api.docuseal.com/templates/html
 * @scope shared
 */
export function createDocumentTemplateFromHtmlOnDocuseal(html: string) {
  return fetch('https://api.docuseal.com/templates/html', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Auth-Token': process.env.DOCUSEAL_TOKEN ?? '',
    },
    body: JSON.stringify({
      html,
      name: 'Generated Document',
      roles: ['Renter'],
    }),
  })
}
